import React from "react";

function BeginnersTutorial() {
    return (
        <div className="container">
            <h2>Beginners Guide to Playing the Dilruba</h2>
            
            <h3>1. Sitting with the Dilruba</h3>
            <p>Sitting with the Dilruba correctly is crucial for proper posture and ease of play. Follow these steps:</p>
            <ul>
                <li>Sit cross-legged on the floor or use a low stool for support.</li>
                <li>Rest the Dilruba on your left shoulder, ensuring it is stable against your chest.</li>
                <li>Hold the bow with your right hand and gently grip the neck of the instrument with your left.</li>
            </ul>
            <p><a href="https://www.youtube.com/watch?v=J7lRphnn-1k">Watch a video guide on how to sit with the Dilruba</a></p>

            <h3>2. Bow Control</h3>
            <p>Controlling the bow is essential for producing a smooth and consistent sound. Practice these techniques:</p>
            <ul>
                <li>Hold the bow lightly but firmly with your thumb and fingers.</li>
                <li>Move the bow evenly across the strings, maintaining a steady pressure.</li>
                <li>Start with long, slow strokes to develop control and consistency.</li>
            </ul>
            <p><a href="https://www.youtube.com/watch?v=E2aBvGy_W4M">Learn bow control techniques in this video</a></p>

            <h3>3. Locating the Notes</h3>
            <p>The Dilruba has frets that help you find notes. Here’s how to get started:</p>
            <ul>
                <li>Familiarise yourself with the Sa Re Ga Ma (Do Re Mi) positions on the fretboard.</li>
                <li>Start by plucking the Sa (root) note to ensure your instrument is tuned correctly.</li>
                <li>Practice moving up and down the scale to learn note positions.</li>
            </ul>
            <p><a href="https://www.youtube.com/shorts/93-vydrcnVM">Watch this guide on finding notes on the Dilruba</a></p>

            <h3>4. Playing Simple Sargam</h3>
            <p>Once you’re comfortable with the notes, start playing simple Sargam patterns:</p>
            <ul>
                <li>Begin with the basic scale: Sa Re Ga Ma Pa Dha Ni Sa.</li>
                <li>Practice playing slowly and increase your speed gradually.</li>
                <li>Experiment with different rhythms and patterns to build your skills.</li>
            </ul>
            <p><a href="https://www.youtube.com/shorts/81TlUPHUX3Q">Learn simple Sargam patterns in this video</a></p>

            <h3>5. Tips for Beginners (Punjabi)</h3>
            <ul>
                <li>Practice regularly to improve your technique and confidence.</li>
                <li>Ensure your instrument is properly tuned before each practice session.</li>
                <li>Take breaks to avoid strain and maintain focus.</li>
            </ul>
            <p><a href="https://www.youtube.com/watch?v=AAKTaUnKbwY">Watch tips for beginners here</a></p>

        </div>
    );
}

export default BeginnersTutorial;
